import React from 'react';

import { Fill, Spinner } from './PreviewPlaceholder.styles';

/** The animated Whitelabels.com loader SVG — the same one the app boots with. */
export const PREVIEW_LOADER_SRC = 'https://micros-t.b-cdn.net/whitelabels.com-loader-1775466124392.svg';

export type PreviewPlaceholderProps = {
  /** Shown (opaque) while the preview iframe loads; fades out once revealed. */
  shown: boolean;
  /** Brand body background (solid) — the flat colour the whole screen fills with. */
  bgColor?: string;
};

/**
 * Full-bleed loading placeholder for a customizer device screen: an opaque
 * brand-coloured surface covering the entire screen, with the animated
 * Whitelabels.com loader centred at 64x64. The loader fades in on appear and out on
 * reveal; the whole surface cross-fades out as the iframe fades in.
 */
export const PreviewPlaceholder = ({ shown, bgColor }: PreviewPlaceholderProps): React.ReactElement => {
  // Fade the loader IN one frame after it appears (mounting at opacity 1 would pop).
  const [loaderIn, setLoaderIn] = React.useState(false);
  React.useEffect(() => {
    if (!shown) {
      setLoaderIn(false);
      return undefined;
    }
    const raf = requestAnimationFrame(() => setLoaderIn(true));
    return () => cancelAnimationFrame(raf);
  }, [shown]);

  return (
    <Fill $shown={shown} $bg={bgColor} aria-hidden>
      <Spinner $shown={loaderIn} src={PREVIEW_LOADER_SRC} alt="" />
    </Fill>
  );
};

export default PreviewPlaceholder;
